import React from 'react'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'
// @ts-ignore
import withLookups, { LookupType } from 'shared/containers/withLookups'

import translate from '../translate'
import { getName, isRequired } from '../../helpers'

const ThirdPage = ({ fields, selects, lookups }) => (
  <GridContainer smallPadding>
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column>
          <FormLayout label="Mobile Access" visible={!!fields.MCLEnabled}>
            <FormField
              name={getName(fields.MCLEnabled)}
              options={selects.MCLEnabled}
              type="select"
              search
              required={isRequired(fields.MCLEnabled)}
            />
          </FormLayout>

          <FormLayout label="Loan Auto Cover" visible={!!fields.AutoCoverPrefID}>
            <FormField
              name={getName(fields.AutoCoverPrefID)}
              options={selects.AutoCoverPref}
              type="select"
              search
              required={isRequired(fields.AutoCoverPrefID)}
            />
          </FormLayout>

          <FormLayout label="Status Level" visible={!!fields.StatusLevelID}>
            <FormField
              name={getName(fields.StatusLevelID)}
              options={selects.StatusLevel}
              type="select"
              search
              required={isRequired(fields.StatusLevelID)}
            />
          </FormLayout>
        </Grid.Column>

        <Grid.Column>
          <FormLayout label={translate('lbl_node')} visible>
            <FormField
              name="NodeID"
              options={lookups.Nodes}
              type="select"
              search
              required={isRequired(fields.NodeID)}
            />
          </FormLayout>

          <FormLayout label={translate('lbl_sdaenabled')} visible={!!fields.SDAEnabled}>
            <FormField
              name={getName(fields.SDAEnabled)}
              options={selects.SDAEnabled}
              type="select"
              search
              required={isRequired(fields.SDAEnabled)}
            />
          </FormLayout>

          <FormLayout label={translate('lbl_smspref_t')} visible={!!fields.SMSPrefID}>
            <FormField
              name={getName(fields.SMSPrefID)}
              options={selects.SMSPref}
              type="select"
              search
              required={isRequired(fields.SMSPrefID)}
            />
          </FormLayout>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <FormLayout label={translate('lbl_cfield1')}>
            <FormField autoFocus type="textarea" name="CField1" required={isRequired(fields.CField1)} />
          </FormLayout>

          <FormLayout label={translate('lbl_cfield2')}>
            <FormField type="textarea" name="CField2" required={isRequired(fields.CField2)} />
          </FormLayout>

          <FormLayout label={translate('lbl_cfield3')}>
            <FormField type="textarea" name="CField3" required={isRequired(fields.CField3)} />
          </FormLayout>

          <FormLayout label={translate('lbl_cfield4')}>
            <FormField type="textarea" name="CField4" required={isRequired(fields.CField4)} />
          </FormLayout>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </GridContainer>
)

export default withLookups({
  type: LookupType.System,
  query: '* as lookups',
})(ThirdPage)
